// extracted by mini-css-extract-plugin
export default {"iconCircle":"noDataModal_iconCircle__ByKOg","title":"noDataModal_title__DYl1U","message":"noDataModal_message__FD-0P","messageBold":"noDataModal_messageBold__f8A0g"};